import React from 'react';
import logo from '../../assets/illustrations/LandingPage/marrom_st_desenho.png';
import flowerWhite from '../../assets/illustrations/LandingPage/flower-white-illustration.png';

const BibliotecaHero: React.FC = () => {
  return (
    <section
      className="relative w-full overflow-hidden min-h-[70vh] flex items-center bg-champagne"
    >
      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 lg:px-16 py-14 lg:py-20">
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-center gap-10 lg:gap-0">

          {/* ── Coluna esquerda: título + ilustração + "no Divã" ── */}
          <div className="flex-shrink-0 flex items-start gap-3 lg:gap-4">

            {/* Texto "O CLUBE / DO LIVRO" + ilustração empilhados */}
            <div className="flex flex-col">
              

              {/* Ilustração */}
              <img
                src={logo}
                alt="Clube do Livro no Divã"
                className="w-[180px] lg:w-[440px] xl:w-[480px] object-contain"
              />
            </div>

         
          </div>

          {/* ── Coluna direita: tagline ── */}
          <div className="w-full flex flex-col justify-start lg:pl-16 xl:pl-24">

            {/* "é" + pequeno texto */}
            <div className="flex items-end justify-end gap-5 mb-3">
              <p className="font-alternate font-bold text-cafe text-[11px] text-right lg:text-[20px] uppercase leading-snug tracking-wider pt-3">
                NÃO É <br /> terapia, é <br />terapêutico 
              </p>
            </div>

            {/* "o livro que te lê." */}
            <div className='border-t-[3px] border-t-laranja w-full  mt-3 lg:mt-0 pt-3 lg:pt-6'>
              <h1 className="font-libre italic text-end text-laranja text-3xl lg:text-4xl xl:text-5xl leading-relaxed lg:leading-relaxed xl:leading-relaxed">
                psicanálise,<br /> literatura e <br />cinema pra <br />se conhecer <br />melhor! 
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Ilustração decorativa – canto direito */}
      <img
        src={flowerWhite}
        alt=""
        aria-hidden="true"
        className="absolute right-0 top-0 h-full w-auto object-cover pointer-events-none opacity-90"
      />
    </section>
  );
};

export default BibliotecaHero;
